// extracted by mini-css-extract-plugin
export default {"imageWrapper":"SN-z","twoColumnImage":"TN-z"};